const names = [
  'Openlane',
  'Yearin',
  'Goodsilron',
  'Condax',
  'Opentech',
  'Golddex',
  'year-job',
  'Isdom',
  'Gogozoom',
  'Y-corporation',
  'Nam-zim',
  'Donquadtech',
  'Warephase',
  'Donware',
  'Faxquote',
  'Sunnamplex',
  'Lexiqvolax',
  'Sumace',
  'Treequote',
  'Iselectrics',
  'Zencorporation',
  'Plusstrip',
  'dambase',
  'Toughzap',
  'Codehow',
  'Zotware',
  'Statholdings',
  'Conecom',
  'Zathunicon',
  'Labdrill',
  'Ron-tech',
  'Green-Plus',
  'Groovestreet',
  'Zoomit',
  'Bioplex',
  'Zumgoity',
  'Scotfind',
  'Dalttechnology',
  'Kinnamplus',
  'Konex',
  'Stanredtax',
  'Cancity',
  'Finhigh',
  'Kan-code',
  'Blackzim',
  'Dontechi',
  'Xx-zobam',
  'Fasehatice',
  'Hatfan',
  'Streethex',
  'Inity',
  'Konmatfix',
  'Bioholding',
  'Hottechi',
  'Ganjaflex',
  'Betatech',
  'Domzoom',
  'Ontomedia',
  'Newex',
  'Betasoloin',
  'Mathtouch',
  'Rantouch',
  'Silis',
  'Plussunin',
  'Plexzap',
  'Finjob',
  'Xx-holding',
  'Scottech',
  'Funholding',
  'Sonron',
  'Singletechno',
  'Rangreen',
  'J-Texon',
  'Rundofase',
  'Doncon',
];

export default names;
